import React, { useState } from "react";
import styles from "./Row.module.sass";
import Actions from "../../components/Actions";
import Tooltip from "../../components/Tooltip";
const StatusEnum = {
	failed: "Failed",
	uncaptured: "Uncaptured",
	refunded: "Refunded",
	partial_refunded: "Partial refunded",
	succeeded: "succeeded",
	cancelled: "Cancelled",
};
const Row = ({ data, clickRefund }) => {
	const date = new Date(data.created * 1000);
	let tooltipValue;
	let style = styles.balance;
	let statusValue = styles.balance;

	const checkCap = (data) => {
		statusValue = data.status;
		if (data.status === "failed") {
			style = styles.failed;
			tooltipValue = `${data.outcome.seller_message}`;
			statusValue = StatusEnum.failed;
			return;
		} else if (
			data.captured === false &&
			data.amount_captured === 0 &&
			data.refunded === false &&
			data.amount_refunded === 0
		) {
			style = styles.uncaptured;
			statusValue = StatusEnum.uncaptured;
			return;
		} else if (
			data.amount === data.amount_refunded &&
			data.refunded === true &&
			data.amount_captured > 0 &&
			data.captured === true
		) {
			style = styles.refunded;
			statusValue = StatusEnum.refunded;
			return;
		} else if (
			data.amount > data.amount_refunded &&
			data.amount_refunded > 0 &&
			data.amount_captured > 0 &&
			data.refunded === false &&
			data.captured === true
		) {
			tooltipValue = `US ${data.amount_refunded / 100} refund was initiated`;
			style = styles.partial_refunded;

			statusValue = StatusEnum.partial_refunded;
			return;
		} else if (
			data.amount === data.amount_captured &&
			data.amount_refunded === 0 &&
			data.captured === true &&
			data.refunded === false
		) {
			style = styles.new;
			statusValue = StatusEnum.succeeded;
			return;
		} else if (
			data.amount === data.amount_refunded &&
			data.amount_captured === 0 &&
			data.captured === false &&
			data.refunded === true
		) {
			style = styles.cancel;
			statusValue = StatusEnum.cancelled;
			return;
		}

		return;
	};
	checkCap(data);
	return (
		<div className={styles.row}>
			<div className={styles.col} />
			{/* <div className={styles.col}>
				<div className={styles.item}>
					<div className={styles.avatar}>
						<img src="https://static.prospin.com.br/media/catalog/product/cache/6e59e4946046b080cb91aa3230980e44/7/e/7ez98yx-g7-raquete-de-tenis-yonex-ezone-98-16x19-305g-2022-azul.jpg" />
					</div>
					<div className={styles.details}>
						<div className={styles.user}>Action name</div>
					</div>
				</div>
			</div> */}
			<div className={styles.col}>
				{
					// `${Sybmols[data.currency.toUpperCase()].symbol_native} ` +
					(data.amount / 100).toLocaleString()
				}
			</div>
			<div className={styles.col}>{data.currency.toUpperCase()}</div>
			<div className={style}>
				{statusValue}{" "}
				{tooltipValue && (
					<Tooltip
						className={styles.tooltip}
						title={tooltipValue}
						icon="info"
						place="top"
					/>
				)}
			</div>
			<div className={styles.col}>{data.destination}</div>
			<div className={styles.col}>{data.id}</div>
			<div className={styles.col}>{date.toLocaleString()}</div>
			{data.refunded === false && statusValue === StatusEnum.succeeded ? (
				<Actions
					classActionsOption={styles.classActionsOption}
					classActionsHead={styles.actionsHead}
					items={[
						{
							title: "Refund payment",
							icon: "ticket",
							action: () => {
								clickRefund(data);
							},
						},
					]}
				/>
			) : (
				<div></div>
			)}
			{/* <div className={styles.col}>Requested</div>
			<div className={styles.col}>
				<button className="button-small">Ship</button>
			</div> */}
		</div>
	);
};

export default Row;
